function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import InsetText from '@govuk-react/inset-text';
import { LINK_COLOUR, LINK_HOVER_COLOUR, FOCUS_COLOUR } from 'govuk-colours';
import { FOCUS_WIDTH, FONT_SIZE, SPACING, NTA_LIGHT } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var HIDDEN_TEXT_FOCUS_WIDTH = parseInt(FOCUS_WIDTH.split('px')[0], 10) + 1 + "px";
var StyledSpan = styled('span')({
  textDecoration: 'underline',
  textDecorationSkipInk: 'none'
});
var StyledSummary = styled('summary')({
  cursor: 'pointer',
  color: LINK_COLOUR,
  fontFamily: NTA_LIGHT,
  fontSize: FONT_SIZE.SIZE_19,
  position: 'relative',
  marginBottom: SPACING.SCALE_1,
  ':hover': {
    color: LINK_HOVER_COLOUR
  },
  ':focus': {
    outline: HIDDEN_TEXT_FOCUS_WIDTH + " solid " + FOCUS_COLOUR,
    // outlineOffset: '-1px', In alpha/govuk-frontend but causes arrow icon to be hidden when open
    background: FOCUS_COLOUR
  }
});
/**
 *
 * ### Usage
 *
 *
 * Simple
 * ```jsx
 * import Paragraph from '@govuk-react/paragraph';
 *
 * <HiddenText summaryText={'Help with nationality'}>
 *   <Paragraph mb={0}>I am a paragraph. Please read me.</Paragraph>
 * </HiddenText>
 * ```
 *
 * ### References
 * - https://govuk-elements.herokuapp.com/typography/#typography-hidden-text
 * - https://github.com/alphagov/govuk-frontend/blob/master/src/components/details/_details.scss
 */

var HiddenText = function HiddenText(_ref) {
  var summaryText = _ref.summaryText,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["summaryText", "children"]);

  return React.createElement("details", props, React.createElement(StyledSummary, null, React.createElement(StyledSpan, null, summaryText)), React.createElement(InsetText, {
    mb: 0,
    isNarrow: true
  }, children));
};

HiddenText.defaultProps = {
  children: undefined
};
export default withWhiteSpace({
  marginBottom: 6
})(HiddenText);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/hidden-text/es/index.js
// module id = 266
// module chunks = 0